import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useLogLoginUIContext } from "./LogLoginUIContext";
import { LogLoginFilter } from "./log-login-table/log-login-filter/LogLoginFilter";
import { fetchLogLoginOrg } from "../../_redux/log-login/logLoginAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import LogLoginTable from "./log-login-table/LogLoginTable";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import { Collapse } from "react-bootstrap";

export const LogLoginCard = ({
  match: {
    params: { id }
  },
  history
}) => {
  // * DECLARE HOOKS
  const dispatch = useDispatch();

  const [openFilter, setOpenFilter] = useState(true);

  // * AccessRole UI Context
  const logLoginUIContext = useLogLoginUIContext();
  const logLoginUIProps = useMemo(() => {
    return {
      queryParams: logLoginUIContext.queryParams,
      setQueryParams: logLoginUIContext.setQueryParams,
    };
  }, [logLoginUIContext]);

  // * Getting curret state of accessRole list from store (Redux)
  const { totalCount, entities, listLoading, actionsLoading } = useSelector(
    state => state.superAdminLogLogin,
    shallowEqual
  );

  useEffect(() => {
    // * Requset ke AccessRole Action
    dispatch(fetchLogLoginOrg(logLoginUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logLoginUIProps.queryParams, dispatch]);


  return (
    <>
      <LoadingAnimation open={false} />
      <Card>
        <CardHeader title="Log Login Organisasi">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn mx-1 btn-warning"
              onClick={() => setOpenFilter(!openFilter)}
            >
              Pencarian
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Collapse in={openFilter}>
            <div className="collapse-filter">
              <LogLoginFilter />
            </div>
          </Collapse>
          <LogLoginTable
            totalCount={totalCount}
            listLoading={listLoading}
            entities={entities}
            queryParams={logLoginUIProps.queryParams}
            setQueryParams={logLoginUIProps.setQueryParams}
          />
        </CardBody>
      </Card>
    </>
  );
};
